/**
 * @Author : ShaJiaJing
 * @Date : 2019/9/5
 * @Version : 1.0
 * @Content : 主题页
 */
export default {
  // 各种状态
  status: {
    activated: 'activated'
  },
  // 录像回放
  play: {
    title: 'Video playback',
    info: ['robot', 'Process', 'Current state', 'Starting time', 'End Time'],
    list: ['Video number', 'address', 'operating system', 'Starting time', 'End Time'],
    tips: ['No video yet！']
  },
  // KEY管理
  license: {
    // 能力管理、应用管理
    index: {
      title: 'KEY management',
      // 概览
      overview: {
        title: 'Overview',
        operation: ['Manage KEY', 'Create KEY'],
        text: 'Created KEY: {n}'
      },
      // 用量
      dosage: {
        title: 'Dosage',
        table: ['Capability product', 'Call volume', 'failure', 'Failure rate'],
        operation: ['see details']
      },
      // 服务列表
      service: {
        title: 'Service list',
        table: ['Component name', 'Free limit', 'Points(point/time)']
      }
    },
    // KEY列表
    list: {
      title: 'KEY List',
      table: ['Name', 'API Key', 'SecretKey', 'Creation time'],
      operation: ['delete', 'Use details', 'create'],
      toggle: ['display', 'hide']
    },
    // 新增应用
    new: {
      title: 'Add KEY',
      form: ['Name', 'description'],
      operation: ['cancel', 'Save and create'],
      rules: ['Name is required']
    }
  },
  // 财务中心
  finance: {
    // 财务总览
    overview: {
      title: 'Financial overview',
      account: {
        title: 'account information',
        label: 'Remaining points',
        operation: 'Recharge'
      },
      consume: {
        title: 'Consumption information',
        content: ['Consumption points today', 'Consumption points this month', 'Pending invoice amount'],
        point: '{n} points'
      }
    },
    // 收支明细
    details: {
      title: 'Financial details',
      fee: 'Free use',
      table: ['Number', 'time', 'product', 'Transaction Type', 'Points', 'Balance'],
      operation: ['Details'],
      conditions: ['time limit', 'KEY', 'product', 'Transaction Type'],
      type: {
        all: 'All',
        consumption: 'consumption',
        recharge: 'recharge'
      },
      detail: {
        title: ' details',
        table: ['product name', 'source', 'time', 'Application name', 'points', 'region', 'Recognition result', 'status']
      }
    }
  },
  // 任务管理
  task: {
    action: {
      0: 'play',
      1: 'redo',
      2: 'start-up',
      3: 'stop',
      4: 'restart',
      5: 'delete',
      6: 'Business log',
      7: 'Run log Download',
      8: 'More'
    }
  }
}
